import axios from "axios";

export const getReeltypes = async () => {
    const response = await axios.get("api/reeltypes");
    const result = response.data;
    return result;
}